<template>
    <div class="container push-widget">
        <div class="row">
            <div class="col-12 form-group">
                <label>{{$t('headings.title')}}</label>
                <input type="text" ref="title" class="form-control" v-model="title">
            </div>
        </div>
        <div class="row">
            <div class="col-12 form-group">
                <label>{{$t('headings.message')}}</label>
                <textarea ref="message" class="form-control" v-model="message"></textarea>
            </div>
        </div>
        <div class="row">
            <div class="col-12 form-check form-check">
                <span>Schedule?</span><br>
                <label class="switch">
                    <input
                        type="checkbox"
                        name=""
                        value="false"
                        v-model="scheduled"
                        />
                    <span class="slider round"></span>
                </label>
            </div>
            <div class="col-12" v-if="scheduled">
                <label>{{$t('headings.date')}}</label>
                <input type="datetime-local" class="form-control" v-model="date">
                <br>
            </div>
        </div>

        <!-- Options Loading Panel -->
        <div class="row" v-if="!hasLoaded">
            <div class="col-12 form-group text-center">
                <div class="card bg-light">
                    <div class="card-body">
                        <p>Loading options, please wait...</p>
                        <div class="spinner-border spinner-border-lg text-primary" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Recipient Selection -->
        <div class="row" v-if="hasLoaded">
            <div class="col-12 form-group">
                <label>{{$t('headings.type')}}</label>
                <select
                    class="custom-select form-control"
                    ref="type"
                    v-on:change="selectType($event)"
                >
                    <option v-for="(type, index) in types" :value="index" :key="index">
                        {{type.title}}
                    </option>
                </select>
            </div>
            <div class="col-6 form-group" v-if="hasChoices">
                <label>{{ $t('headings.select') + ' ' + this.getTypeTitle() }}</label>
                <select
                    class="custom-select form-control"
                    ref="choice"
                    v-model="selectedStory"
                >
                    <option v-for="(choice, index) in type.choices || []" :key="index" ref="choice" :value="choice.id">
                        {{choice.title}}
                    </option>
                </select>
            </div>
        </div>


        <div class="row">
            <div class="col-auto">
                <button v-if="scheduled" class="btn btn-dark" @click="schedulePush($event)">{{$t('interface.btnSchedule')}}</button>
                <button v-else class="btn btn-dark" @click="sendPush($event)">{{$t('interface.btnSend')}}</button>
            </div>
            <div class="col" :class="{ 'text-success': !hasError, 'text-danger': hasError }">
                {{notification}}
            </div>
        </div>

        <br><hr><br>

        <div class="row" v-if="pushNotifications.length">
            <div class="col-12">
                <h2><fa-icon icon="clock"></fa-icon> {{$t('headings.scheduled')}}</h2>
                <table class="table table-hover">
                    <caption></caption>
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">{{$t('headings.title')}}</th>
                            <th scope="col">{{$t('headings.date')}}</th>
                            <th scope="col">Send to</th>
                            <th scope="col">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="file-row" v-for="(push, index) in pushNotifications" :key="index">
                            <td>{{push.id}}</td>
                            <td>{{push.title}}</td>
                            <td>{{push.date}}</td>
                            <td>{{push.choice}}</td>
                            <td>
                                <a class="clickable btn btn-danger" href="#" @click.prevent="deleteScheduled(push.id)"><fa-icon icon="trash-alt"></fa-icon></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import DatePicker from 'v-calendar/lib/components/date-picker.umd';
    import VueTimepicker from 'vue2-timepicker';
    import 'vue2-timepicker/dist/VueTimepicker.css';

    export default {
        props: {
            route_send: String,
            route_schedule: String,
            route_options: String,
        },
        methods: {
            sendPush(event) {
                const route = this.$props.route_send;
                const selectedTypeIndex = this.$refs.type.selectedIndex;

                // Construct payload to push wooosh
                const payload = {
                    action: this.types[selectedTypeIndex].action,
                    choice: this.selectedStory,
                    message: this.message,
                    title: this.title,
                }

                // Attach data json, if any
                const data = this.getDataPayload();
                if (data) {
                    payload.data = data;
                }

                // Send request to PushWoosh
                axios.post(route, payload).then((response) => {
                    const data = response.data;

                    this.notify(data.message);

                    // Reset
                    this.message = '';
                    this.title = '';
                }).catch((err) => {
                    console.error(err);
                    if (err.response) {
                        this.notify(err.response.data.message, true);
                        return;
                    };
                    this.notify(err.message, true);
                });
            },
            schedulePush(event) {
                // Construct payload to push wooosh
                const selectedTypeIndex = this.$refs.type.selectedIndex;
                const payload = {
                    action: this.types[selectedTypeIndex].action,
                    choice: this.selectedStory,
                    message: this.message,
                    title: this.title,
                    date: this.date
                }

                // Attach data json, if any
                const data = this.getDataPayload();
                if (data) {
                    payload.destination_type = data.type;
                    payload.destination_id   = data.index;
                }

                // Schedule Push
                axios.post(this.route_schedule, payload).then((response) => {
                    this.notify('The push notification is scheduled');
                    this.fetchScheduled();

                    // Reset
                    this.message = '';
                    this.title = '';
                }).catch((err) => {
                    console.log(err);
                    if (err.response) {
                        this.notify(err.response.data.message, true);
                        return;
                    }
                    this.notify(err.message, true);
                });
            },
            deleteScheduled(id) {
                let confirm = window.confirm(`Scheduled push with id: ${id} will be deleted. Please confirm!`);
                if (!confirm) {
                    return false
                }

                axios.delete(`${this.route_send}/${id}`).then(res => {
                    this.fetchScheduled();
                }).catch((err) => {
                    console.log(err);
                    if (err.response) {
                        this.notify(err.response.data.message, true);
                        return;
                    }
                    this.notify(err.message, true);
                });
            },
            fetchScheduled() {
                axios.get(this.route_send).then(response => {
                    this.pushNotifications = response.data
                })
            },
            notify(message, error = false) {
                // Set error
                this.hasError = error || false;

                // Display notification
                this.notification = !this.hasError ? '✓ ' : '˟ ';
                this.notification += message || this.$t('messages.sent');

                // Clear after timeout
                setTimeout(() => {
                    this.notification = null;
                    this.hasError = false;
                }, 1500);
            },
            selectType(event) {
                const index = event.srcElement.value;
                const type = this.types[index];
                this.type = type;
            },
            selectPayload(event) {
                const index = event.srcElement.value;
                const payload = this.payloads[index];
                this.payload = payload;
            },
            getTypeTitle() {
                return this.type.resource_name || this.$t('headings.fallbackResourceName');
            },
            getDataPayload() {
                // Make sure payload is selected
                if (this.payload === undefined) {
                    return false;
                }

                // Get payload key/value pair
                const payload = {};
                const refKey = this.payload.action + 'Payload';
                const ref = this.$refs[refKey];
                const key = this.payload.action;
                console.log(refKey);
                console.log(ref);
                payload[key] = parseInt(ref.value);

                return payload;
            }
        },
        data: function () {
            return {
                type: [],
                title: '',
                message: '',
                notification: '',
                date: '',
                selectedStory: null,
                scheduled: false,
                hasLoaded: false,
                hasError: false,
                payload: undefined,
                payloads: [],
                types: [],
                pushNotifications: [],
            };
        },
        computed: {
            hasChoices: function() {
                if (!this.type.choices) return false;
                return this.type.choices.length > 0;
            }
        },
        components: {
            'date-picker': DatePicker,
            'time-picker': VueTimepicker
        },
        mounted: function() {
            // Fetch scheduled push notifications
                this.fetchScheduled();

            // Fetch options
            axios.get(this.route_options).then((response) => {
                this.types = response.data.recipients || [];
                this.payloads = response.data.payloads || []
                this.hasLoaded = true;
            });
        },
        i18n: {
            locale: 'en',
            messages: {
                en: {
                    interface: {
                        btnSend: 'Send',
                        btnSchedule: 'Schedule',
                    },
                    headings: {
                        type: 'Send push to',
                        select: 'Choose ',
                        fallbackResourceName: 'one',
                        title: 'Title',
                        message: 'Message',
                        date: 'Publication date',
                        scheduled: 'Scheduled',
                    },
                    messages: {
                        sent: 'The message has been sent.',
                    },
                },
                sv: {
                    interface: {
                        btnSend: 'Skicka',
                        btnSchedule: 'Schemalägg'
                    },
                    headings: {
                        type: 'Skicka push till',
                        select: 'Välj ',
                        fallbackResourceName: 'en',
                        title: 'Titel',
                        message: 'Meddelande',
                        date: 'Publiceringsdatum',
                        scheduled: 'Schemalagda'
                    },
                    messages: {
                        sent: 'Meddelandet har skickats.',
                    },
                },
            },
        },
    };
</script>

<style scoped>
.inactive .type,
.inactive .name,
.inactive .index {
    opacity: 0.4;
}
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 52px;
  height: 25px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.dates-btn {
  margin-bottom: 5px;
}
</style>
